export const SET_RETURN_IS_PENDING =
  'rpb2b-react/returns/SET_RETURN_IS_PENDING';
export type SET_RETURN_IS_PENDING = typeof SET_RETURN_IS_PENDING;

export const SET_RETURN_ERROR = 'rpb2b-react/returns/SET_RETURN_ERROR';
export type SET_RETURN_ERROR = typeof SET_RETURN_ERROR;

export const SET_RETURN_LAST_RMA_CODEBAR =
  'rpb2b-react/returns/SET_RETURN_LAST_RMA_CODEBAR';
export type SET_RETURN_LAST_RMA_CODEBAR = typeof SET_RETURN_LAST_RMA_CODEBAR;

export const SET_RETURN_ELIGIBLE_DATA =
  'rpb2b-react/returns/SET_RETURN_ELIGIBLE_DATA';
export type SET_RETURN_ELIGIBLE_DATA = typeof SET_RETURN_ELIGIBLE_DATA;

export const SET_RETURN_ELIGIBLE_CORE_DATA =
  'rpb2b-react/returns/SET_RETURN_ELIGIBLE_CORE_DATA';
export type SET_RETURN_ELIGIBLE_CORE_DATA = typeof SET_RETURN_ELIGIBLE_CORE_DATA;

export const SET_RETURN_STATUS_DATA =
  'rpb2b-react/returns/SET_RETURN_STATUS_DATA';
export type SET_RETURN_STATUS_DATA = typeof SET_RETURN_STATUS_DATA;

export const SET_RETURN_RMA_LIST = 'rpb2b-react/returns/SET_RETURN_RMA_LIST';
export type SET_RETURN_RMA_LIST = typeof SET_RETURN_RMA_LIST;

export const SET_RETURN_PARTS_TO = 'rpb2b-react/returns/SET_RETURN_PARTS_TO';
export type SET_RETURN_PARTS_TO = typeof SET_RETURN_PARTS_TO;

export const SET_RETURN_ALERT = 'rpb2b-react/returns/SET_RETURN_ALERT';
export type SET_RETURN_ALERT = typeof SET_RETURN_ALERT;

export const SET_RETURN_STATUS_ALERT =
  'rpb2b-react/returns/SET_RETURN_STATUS_ALERT';
export type SET_RETURN_STATUS_ALERT = typeof SET_RETURN_STATUS_ALERT;

export const SET_RETURN_IS_DOWNLOADING_PDF =
  'rpb2b-react/returns/SET_RETURN_IS_DOWNLOADING_PDF';
export type SET_RETURN_IS_DOWNLOADING_PDF = typeof SET_RETURN_IS_DOWNLOADING_PDF;

export const SET_MODAL_IF_RETURN_ERROR =
  'rpb2b-react/returns/SET_MODAL_IF_RETURN_ERROR';

export default {
  SET_RETURN_IS_PENDING,
  SET_RETURN_ERROR,
  SET_RETURN_ELIGIBLE_DATA,
  SET_RETURN_ELIGIBLE_CORE_DATA,
  SET_RETURN_STATUS_DATA,
  SET_RETURN_PARTS_TO,
  SET_RETURN_RMA_LIST,
  SET_RETURN_ALERT,
  SET_RETURN_IS_DOWNLOADING_PDF,
  SET_RETURN_STATUS_ALERT,
  SET_MODAL_IF_RETURN_ERROR
};
